"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FordFBATypes = {
    none: 0,
    gold: 1,
    blue: 2,
    lincolnCPO: 3
};
